import React, { Component } from 'react';

import 'bootstrap-social/bootstrap-social.css';
import './style.css'

import logo_becas from '../../imgs/becas-en-red.png';

class MoreInfoModal extends Component {
  render() {
    const course = this.props.course;

    return <div className="modal fade" id={`more-info-${course.id}`} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <div className="modal-info">
              <div className=""><h5>{ course.name }</h5></div>
              <div className="">
                <h3><small className="text-muted level">{ course.school }</small></h3>
              </div>
              <div className="">
                <small className="text-muted level">
                  { course.maxAge >= 100 || course.maxAge === 0
                    ? `A partir de los ${ course.minAge } años`
                    : `De ${ course.minAge } a ${ course.maxAge } años`
                  }
                </small>
              </div>
            </div>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="modal-info">
              <div className="" style={{marginBottom: '20px'}}>{ course.description }</div>
              <div className=""><strong>Horario:</strong> { course.schedule }</div>
              <div className=""><strong>Precio:</strong> { course.price ? `$ ${course.price}` : 'No informado' }</div>
            </div>
          </div>
          <div className="modal-footer">
            <div className="contact">
              {
                course.contact && course.contact.map((x, index) => {
                  switch (x.tipo) {
                    case 'mail':
                      return (<a key={`${x.tipo}${x.id}`} href={ `mailto:${x.valor}` } target="_blank" className="contact-icon"> <i className="fas fa-at"></i></a>);
                    case 'web':
                      return (<a key={`${x.tipo}${x.id}`} href={ x.valor } target="_blank" className="contact-icon"> <i className="fas fa-globe"></i></a>);
                    case 'facebook':
                      return (<a key={`${x.tipo}${x.id}`} href={ x.valor } target="_blank" className="contact-icon"> <i className="fab fa-facebook"></i></a>);
                    case 'twitter':
                      return (<a key={`${x.tipo}${x.id}`} href={ x.valor } target="_blank" className="contact-icon"> <i className="fab fa-twitter"></i></a>);
                    case 'instagram':
                      return (<a key={`${x.tipo}${x.id}`} href={ x.valor } target="_blank" className="contact-icon"> <i className="fab fa-instagram"></i></a>);
                    case 'youtube':
                      return (<a key={`${x.tipo}${x.id}`} href={ x.valor } target="_blank" className="contact-icon"> <i className="fab fa-youtube"></i></a>);
                    default:
                      return null;
                  }
                })
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

class CourseBox extends Component {
  constructor() {
    super();
    this.onCourseClick = this.onCourseClick.bind(this);
    this.onImageError = this.onImageError.bind(this);
    this.state = {};
  }

  onCourseClick() {
    const selectFunc = this.props.onScolarshipSelected || function () {};
    selectFunc(this.props.course.id);
  }

  onImageError() {
    this.setState({image: logo_becas});
  }

  render() {
    const course = this.props.course;
    const selected = this.props.selected || false;
    // const image = `/imgs/${course.school.trim().toLowerCase().replace(/[^\w]/g, '-')}.png`;
    const current_image = course.imageUrl ? course.imageUrl : logo_becas;
    return <React.Fragment>
      <section title={ course.description } className={`container shadow-box ${selected ? 'selected' : ''}`}>
      <div className="row no-gutters">
        <div onClick={ this.onCourseClick } className="col-3">
          <div className="logo-container">
            {
              course.web
              ? <a href={ course.web } target="_blank"><img src={ current_image } onError={this.onImageError} alt={ course.school } /></a>
              : <img src={ current_image } alt={ course.school } onError={this.onImageError} />
            }
          </div>
        </div>
        <div className="col-9">
          <div onClick={ this.onCourseClick } className="info">
            <h3>
              <strong>{ course.name }</strong>
              <small className="text-muted level">{ course.school }</small>
            </h3>
            <h3>
              <small className="text-muted level">{ course.level }</small>
            </h3>
            <div onClick={ this.onCourseClick } className="course-info">
              <div className={`schedule ${course.schedule.length > 100 ? 'long-schedule' : null}`}>{ course.schedule.toLowerCase() }</div>
              { course.maxAge >= 100 || course.maxAge === 0
                ? <strong>A partir de los { course.minAge } años </strong>
                : <strong>De { course.minAge } a { course.maxAge } años</strong>
              }
            </div>
            <div className="contact">
              <div className="more-info">
                <button className="more-info-button" data-toggle="modal" data-target={`#more-info-${course.id}`}>Más info</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <MoreInfoModal course={ course } />
    </React.Fragment>
  }
}

export default CourseBox;



// WEBPACK FOOTER //
// ./src/components/CourseBox/Component.js